import React from 'react';
import PropTypes from 'prop-types';
import Relay from 'react-relay';
import PagingGrid, {defaultPageSize, processPagingParams} from '../fw/PagingGrid.react';
import AppPanel from '../fw/AppPanel.react';

import types from '../../common/model-api/types';
import urlMapping from '../app/URLMapping';
import AddButton, {AddButtonAbove} from '../fw/AddButton.react';
import {injectIntl, defineMessages, IntlShape} from 'react-intl';
import {wrapNotFound} from '../app/NotFoundHandler.react';
import {getLastOrganisationId} from '../app/LastOrganisationId';
import { User } from '../../common/types/types';

const messages = defineMessages({
    title: {id: 'relationDefList.title', 'defaultMessage': 'Relation definition list'}
});

interface RelationDefListProps {
    intl: IntlShape;
    relay?: object;
    user: User;
}

class RelationDefList extends React.Component<RelationDefListProps> {

    typeName = 'relationDefs';

    static propTypes = {
        intl: PropTypes.object.isRequired,
        relay: PropTypes.object,
        user: PropTypes.object.isRequired
    };

    constructor() {
        super();
    }

    render() {
        const {relationDefs} = this.props.user.organisation;
        const list = relationDefs;
        let type = types[this.typeName];

        return (
            <AppPanel breadcrumbParams={[
                {type: types['organisations'], data: this.props.user.organisation}]
            } title={this.props.intl.formatMessage(messages.title)}>
                <div>
                    <AddButtonAbove list={list.edges} metadata={type} organisationId={this.props.user.organisation.realId} parent={this.props.user.organisation} urlMapping={urlMapping} />

                    <PagingGrid
                        columns={['name', 'type', 'fromChannel.name', 'fromChannel.channelDef.name', 'fromEntity.name', 'fromField.name', 'toChannel.name', 'toChannel.channelDef.name', 'toEntity.name', 'toField.name']}
                        edges={list}
                        metadata={type}
                        pageInfo={list.pageInfo}
                        relay={this.props.relay}
                        urlMapping={urlMapping}
                    />

                    <AddButton metadata={type} organisationId={this.props.user.organisation.realId} parent={this.props.user.organisation} urlMapping={urlMapping} />
                </div>
            </AppPanel>
        );
    }
}

export default Relay.createContainer(wrapNotFound(injectIntl(RelationDefList), (props) => {
    return props.user.organisation;
}), {
    initialVariables: {
        organisationId: '',
        first: defaultPageSize,
        after: null,
        before: null,
        last: null,
    },
    prepareVariables (variables) {
        processPagingParams(variables);

		if (!variables.organisationId) {
			variables.organisationId = getLastOrganisationId();
		}

        return variables;
    },
    fragments: {
        user: () => Relay.QL`
            fragment on User {
                organisation(id: $organisationId) {
                    id,
                    realId,
                    name,
                    relationDefs(first: $first, after: $after, before: $before, last: $last) {
                        edges {
                            node {
                                id,
                                name,
                                type,
                                organisation {
                                    id
                                },
                                organisation_id,
                                fromChannel {
                                    id,
                                    name,
                                    channelDef {
                                        id,
                                        name
                                    }
                                },
                                toChannel {
                                    id,
                                    name,
                                    channelDef {
                                        id,
                                        name
                                    }
                                },
                                fromEntity {
                                    id,
                                    name,
                                    key
                                },
                                toEntity {
                                    id,
                                    name,
                                    key
                                },
                                fromField {
                                    id,
                                    name,
                                    key
                                },
                                toField {
                                    id,
                                    name,
                                    key
                                }
                            }
                        },
                        pageInfo {
                            hasNextPage,
                            hasPreviousPage,
                            startCursor,
                            endCursor
                        }
                    }
                }
            }
        `,
    },
});
